import React from 'react';
import BottomNav from '../components/BottomNav';

const LeadershipInvestments = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Leadership Investments</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Strategic Investment Opportunities</p>
        
        <div className="card">
          <p>
            Access exclusive investment opportunities typically reserved for institutional investors. 
            Build wealth through strategic partnerships and alternative investments.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Private Equity</h3>
              <p>Exclusive access to pre-IPO and private investments</p>
            </div>
            <div className="feature-item">
              <h3>Alternative Assets</h3>
              <p>Diversify with art, collectibles, and unique opportunities</p>
            </div>
            <div className="feature-item">
              <h3>Deal Flow</h3>
              <p>First access to premium investment opportunities</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default LeadershipInvestments;
